var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[_c('van-nav-bar',{attrs:{"title":"用户注册及协同宝App隐私协议","left-text":"","left-arrow":""},on:{"click-left":_vm.onClickLeft}}),_c('uesrLicenseVue',{staticClass:"uesrLicenseStyle"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }